import { useRef } from 'react';
import '../style/About.scss';
import { useScrollSlideIn, useScrollParallax } from '../hooks/useScrollTrigger';

function About(props) {
    const pic1 = useRef(null);
    const foregroundWave = useRef(null);
    const midgroundWave = useRef(null);
    const backgroundWave = useRef(null);

    // Slide in from left animation
    useScrollSlideIn(pic1, {
        direction: 'left',
        distance: 500,
        ease: 'power3',
    });

    // Wave parallax - deeper layers move faster left and slightly up
    useScrollParallax(foregroundWave, {
        to: { x: '-50%' },
        start: 'top bottom',
        end: 'bottom top',
    });

    useScrollParallax(midgroundWave, {
        to: { x: '-55%', y: -50 },
        start: 'top bottom',
        end: 'bottom top',
    });

    useScrollParallax(backgroundWave, {
        to: { x: '-60%', y: -100 },
        start: 'top bottom',
        end: 'bottom top',
    });

    return (
        <div className='section2' ref={props.aboutRef}>
            <div className='backgroundWaves'>
                <img className='bgWave background' ref={backgroundWave} src="svgs/background_wave.svg" alt='background wave' />
                <img className='bgWave midground' ref={midgroundWave} src="svgs/midground_wave.svg" alt='background wave' />
                <img className='bgWave foreground' ref={foregroundWave} src="svgs/foreground_wave.svg" alt='background wave' />
            </div>
            <div className='leftSide' ref={pic1}>
                <img className='me' src="images/about-image.jpeg" alt='Ty and Issy' />
            </div>
            <div className='rightSide' id='about'>
                <h1 className='header'>About Me</h1>
                <p>
                    Ever since I was young, I have had an artistic side. I started on pencil and paper and 
                    more recently have found the world of web development. Through my schooling and in my freetime, 
                    I have taught myself how to code and have found a passion for it. I am always looking for new
                    ways to improve my skills and learn new things. In my free time I have numerous side projects 
                    ranging from personal projects to freelance work. I am always looking for new opportunities to
                    learn and grow as a developer.
                </p>
            </div>
        </div>
    );
}

export default About;